import React from 'react'

export default function Heading({title}) {
    return (
        <div className='row'>

        <div class='col text-dark text-center mb-4'>
        <h1 className='display-3'>{title}</h1>
            
        </div>
            
        </div>
    )
}
